<template>
<ol class="dd-list list-unstyled">
    <li v-for="folder in children" :key="folder.name" class="dd-item">
        <div class="cardbox b0 dd-handle" :class="{'text-white bg-info': folder.selected, 'disabled': is_folder_original_parent(folder)}">
            <div class="cardbox-body namespace-folder-box" :class="[is_folder_original_parent(folder) ? 'c-not-allowed' : 'c-pointer' ]"  @click.stop="is_folder_original_parent(folder) ? false : clicked(folder)">
                <div class="d-flex align-items-center" :class="'color-' + ( folder.color ) + '-400'">
                    <div class="mr-2"><i class="ion-folder" :class="{'text-white': folder.selected }"></i></div>
                    <div>
                        <div class="folder-name" :class="{'text-white text-bold': folder.selected}">{{ folder.name }}</div>
                    </div>
                </div>
            </div>
        </div>

        <namespace-tree-row 
            v-if="folder.children && folder.children.length > 0" 
            :orig_parent_id="orig_parent_id"
            :loaded_namespace_id="loaded_namespace_id"
            :children="folder.children" 
            :clicked="clicked" 
        />
    </li>
</ol>
</template>
<script>
import { NamespaceService } from '@/services/namespace-service';



export default {
    name: "namespace-tree-row",
    props: {
        loaded_namespace_id: String, // 'id' of the namespace that is being listed (target where the entities will be moved/copied to)
        orig_parent_id: Number, // Original parent ID of the entities
        children: { type: Array, default: ()=>[] }, // Folders to display
        clicked: Function // Handler when a folder is clicked
    },
    beforeCreate() {
        // Self-importing this component:
        // https://v2.vuejs.org/v2/guide/components-edge-cases.html#Recursive-Components
        this.$options.components.namespaceTreeRow = require('./namespace-tree-row.vue').default
    },
    methods: {
        is_folder_original_parent(folder){
            // Whether the given folder is the original parent of the copied/moved entities
            // The original parent is not selectable as the target.

            // What is the current namespace (where the copied/moved entities currently reside)
            const orig_namespace_id = `${NamespaceService.ns_type}-${NamespaceService.ns_key||''}`
            // Folder IDs are unique across namespaces, but the root is '-1' or 'null' everywhere.
            // Therefore, we need to check whether the listed namespace is the same as the original
            return orig_namespace_id == this.loaded_namespace_id && 
                    (folder.id == this.orig_parent_id || (folder.id == -1 && this.orig_parent_id === null))
        }
    }
}
</script>
<style scoped>

.dd-item{
    font-size: inherit;
    line-height: inherit;
}

.ion-folder{
    font-size: 2em;
    line-height: 0px;
}

.namespace-folder-box{
    padding: .2em 1em !important
}

@media (max-width: 992px) {
    .ion-folder{
        font-size: 1.5em;
    }
    .namespace-folder-box{
        padding: .2em .8em  !important
    }
}

.cardbox.disabled{
    background-color: #e0e0e0; /* bg-grey-300 */
    font-style: italic;
}

.theme-dark .cardbox,
.theme-ironshard .cardbox{
    /* Dark bg in dark themes, otherwise there is not enough contrast between the box and the bg */
    background-color: #2e2e2e
}

.theme-dark .cardbox .folder-name,
.theme-ironshard .cardbox .folder-name{
    /* In dark mode the folder names are white in the file list, they should be also white here  */
    color: white 
}

.theme-dark .cardbox.disabled,
.theme-ironshard .cardbox.disabled{
    background-color: #565656;
}
</style>
